import React from 'react';
import { connect } from 'react-redux';
import ChildIcon from 'components/icons/favorite';
import BookIcon from 'components/icons/design';
import PencilIcon from 'components/icons/pencil';
import SaveIcon from 'components/icons/save';
import HelpIcon from 'components/icons/help';
import OrderIcon from 'components/icons/order';
import ProfileIcon from 'components/icons/profile';

import { MenuItem } from 'components';

import { setSidebar } from 'redux/reducers/app';
import { isAuthenticated } from 'redux/selectors/user';

import { forcedSidebar } from 'redux/selectors/app';
import { canEdit } from 'redux/selectors/orders';
import { trackEvent } from 'redux/reducers/user';

import cx from 'classnames';
import styles from './styles.scss';

const icons = {
  pencil: <PencilIcon width={35} height={35} />,
  book: <BookIcon width={35} height={35} />,
  child: <ChildIcon width={35} height={30} />,
  help: <HelpIcon width={35} height={35} />,
  order: <OrderIcon width={35} height={42} />,
  profile: <ProfileIcon width={35} height={35} />,
  save: <SaveIcon width={35} height={35} />,
};

@connect(
  state => ({
    authenticated: isAuthenticated(state),
    canEdit: canEdit(state),
    sidebar: forcedSidebar(state),
  }),
  {
    setSidebar,
    trackEvent,
  }
)
export default class Menu extends React.PureComponent {
  setSidebar = e => {
    const item = e.currentTarget.dataset.sidebar;
    this.props.setSidebar(item);
  };

  trackClick = e => {
    this.props.trackEvent('help_clicked', {});
  };

  render() {
    const { orderId, canEdit, sidebar, authenticated } = this.props;
    const classes = cx(styles.menu, {
      [styles.cantEdit]: !canEdit,
    });

    return (
      <div className={classes}>
        <ul className={styles.center}>
          {authenticated ? (
            <li>
              <MenuItem
                data-sidebar="myOrders"
                active={sidebar === 'myOrders' || sidebar === 'profile' || sidebar === 'login'}
                onClick={this.setSidebar}
                icon={icons.profile}>
                {kroostApp.strings.menuAccount}
              </MenuItem>
            </li>
          ) : (
            <li>
              <MenuItem
                data-sidebar="makeAccount"
                active={sidebar === 'makeAccount'}
                onClick={this.setSidebar}
                icon={icons.profile}>
                {kroostApp.strings.menuAccount}
              </MenuItem>
            </li>
          )}
          <li className={!orderId ? styles.needsEdit : ''}>
            <MenuItem data-sidebar="order" active={sidebar === 'order'} onClick={this.setSidebar} icon={icons.order}>
              {kroostApp.strings.menuOrder}
            </MenuItem>
          </li>
          <li className={styles.needsEdit}>
            <MenuItem data-sidebar="child" active={sidebar === 'child'} onClick={this.setSidebar} icon={icons.child}>
              {kroostApp.strings.menuChild}
            </MenuItem>
          </li>
          {/*<li className={styles.needsEdit}>*/}
          {/*  <MenuItem*/}
          {/*    data-sidebar='design'*/}
          {/*    active={sidebar === 'design'}*/}
          {/*    onClick={this.setSidebar}*/}
          {/*    icon={icons.book}*/}
          {/*  >*/}
          {/*    {kroostApp.strings.menuDesigns}*/}
          {/*  </MenuItem>*/}
          {/*</li>*/}
          <li className={styles.needsEdit}>
            <MenuItem data-sidebar="photos" active={sidebar === 'photos'} onClick={this.setSidebar} icon={icons.pencil}>
              {kroostApp.strings.menuPhotos}
            </MenuItem>
          </li>
        </ul>
        <ul className={styles.bottom}>
          <li>
            <MenuItem
              to={`https://kroost.${global.kroostApp.domainExtension}/designer-faq`}
              target="_blank"
              icon={icons.help}
              onClick={this.trackClick}>
              {kroostApp.strings.menuHelp}
            </MenuItem>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/menu/index.js